// extracted by mini-css-extract-plugin
export default {"main":"pcModal_main__FWYNo","button_row":"pcModal_button_row__7E0oz","background":"pcModal_background__BjPSP","modal_sent":"pcModal_modal_sent__tqa6Q"};